"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@opensea/navigation";
import { Media } from "@opensea/ui-kit";
import { TopNavbarContainer } from "./TopNavbarContainer";
export function MobileNavbarContainer(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const isMobile = pathname !== "/" && !pathname.includes("/discover");
  let t1;
  if ($[0] !== children || $[1] !== isMobile) {
    t1 = <Media lessThan="lg"><TopNavbarContainer isMobile={isMobile}>{children}</TopNavbarContainer></Media>;
    $[0] = children;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}